export default __webpack_public_path__ + "static/media/element_73.60fb82a8.avif";